import { allTrackers } from "app/services/track/track";

import createLeadsSearchFiltersTrackingService from "./factory";

const leadsSearchFiltersTrackingService = createLeadsSearchFiltersTrackingService(allTrackers);

export default leadsSearchFiltersTrackingService;
